import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=1cf135ed&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=1cf135ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf135ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCheckbox,VIcon,VList,VListItem,VMenu})
